import LegalNotices from './LegalNotices';

export default {
  path: 'legalNotices',

  getComponents(location, cb) {
    cb(null, LegalNotices);
  },
};
